import React, { useState, useEffect, useContext } from 'react';
import { PanelType } from '@fluentui/react';
import { API } from '../../../../API/API';
import FieldText from '../../../../components/FieldText/FieldText';
import FieldDropdown from '../../../../components/FieldDropdown/FieldDropdown';
import ButtonDefault from '../../../../components/ButtonDefault/ButtonDefault';
import { MessageConst } from '../../../../const/MessageConst';
import { message } from 'antd';
import FieldEmployee from '../../../../components/FieldEmployee/FieldEmployee';
import { UserContext } from '../../../../context/UserContext';
import FieldDropdownMulti from '../../../../components/FieldDropdownMulti/FieldDropdownMulti';
import ButtonSecondary from '../../../../components/ButtonSecondary/ButtonSecondary';
import { constData } from '../../../../const/Const';
import PanelBase from '../../../../components/PanelBase/PanelBase';

const UserNew = (props) => {

    //tblUser.status
    //A - идэвхтэй,
    //I - идэвхгүй,
    //L - түгжсэн,
    //D - устгасан

    let userid = null;
    if (props.userid)
        userid = props.userid;
    const { userInfo } = useContext(UserContext);
    const [initData, setInitData] = useState({
        "userid": null,
        "password": null,
        "empid": null,
        "email": null,
        "roleid": null,
        "status": "A",
        "licenseid": null,
        "datafilter": null,
        "depids": [],
        "ispasswordchanged": false,
        "fullname": null,
        "tstamp": null
    });
    const [data, setData] = useState({ ...initData });
    const [checkRule, setCheckRule] = useState(false);
    const [warning, setWarning] = useState();
    const [depData, setDepData] = useState([]);
    const [roleData, setRoleData] = useState([]);
    const [dType, setDType] = useState(constData.User_Status);
    const [isLoad, setIsLoad] = useState(false);

    useEffect(() => {
        dataLoad();
    }, [props.userid]);

    const dataLoad = async () => {
        if (props.userid) {
            await getData(props.userid);
        } else {
            setData({ ...initData });
        }
    }

    useEffect(() => {
        getInitData();
    }, []);

    const getData = async (param) => {
        if (param) {
            userid = param;
            setIsLoad(true);
            let tempData = [];
            await API.get('/api/shared/user-management/user?userid=' + param).then(response => {
                if (response.status === 200 && response.data.rettype === 0) {
                    if (response.data?.retdata) {
                        tempData = response.data?.retdata;
                    }
                }
            });
            setData(tempData);
            setIsLoad(false);
        }
    }

    const getInitData = async () => {
        setIsLoad(true);
        let tempDepData = [];
        let tempRolData = [];
        await API.get('/api/humanresource/organization/get_department_dropdown?companyid=' + userInfo.companyid.toUpperCase()).then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                if (response.data?.retdata)
                    tempDepData = response.data?.retdata;
            }
        });
        await API.get('/api/shared/user-management/role/DropDown').then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                if (response.data?.retdata)
                    tempRolData = response.data?.retdata;
            }
        });
        setDepData(tempDepData);
        setRoleData(tempRolData);
        setIsLoad(false);
    }

    const fieldOnChanged = async (key, text, field, email) => {
        if (field) {
            let tData = { ...data };
            tData[field] = key;
            if (field === 'password')
                tData['ispasswordchanged'] = true;
            if (field === 'empid' && email?.length > 0)
                tData['email'] = email;
            setData(tData);
        }
    }

    const onRenderList = (owner) => {
        owner?.options?.forEach(element => {
            if (element.issystem == 'Y')
                element.hidden = true;
        });
    }

    const onSave = async (p_close) => {
        let isValid = true;
        if (!data.userid) {
            isValid = false;
            setWarning("Нэвтрэх нэр" + MessageConst.fieldRequired);
        } else if (!data.email) {
            isValid = false;
            setWarning("И-мэйл" + MessageConst.fieldRequired);
        } else if (!data.password) {
            isValid = false;
            setWarning("Нууц үг" + MessageConst.fieldRequired);
        } else if (!data.roleid) {
            isValid = false;
            setWarning("Үүрэг" + MessageConst.fieldRequired);
        }
        if (isValid) {
            await API.post('/api/shared/user-management/user', data).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    message.success(MessageConst.success);
                    setData({ ...initData });
                    if (props.afterSave) {
                        props.afterSave(p_close);
                    }
                } else if (response.data.rettype != 0 && response.data.retmsg.startsWith('ORA-00001')) {
                    message.error("Нэвтрэх нэр давхцаж байна!");
                }
            });
        }
    }

    const onDelete = async (p_close) => {
        await API.delete('/api/shared/user-management/user?userID=' + props.userid).then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                message.success(MessageConst.success);
                if (props.afterSave) {
                    props.afterSave(p_close);
                }
            }
        });
    }

    return (
        <PanelBase
            headerText={userid ? 'Хэрэглэгч засах' : 'Хэрэглэгч нэмэх'}
            isOpen={props.isOpen}
            onDismiss={props.onDismiss}
            type={PanelType.medium}
            isFooterAtBottom={true}
            onDelete={() => onDelete(true)}
            warning={warning}
            delete={userid}
            buttons={
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <div>
                        <ButtonSecondary onClick={() => onSave(false)} text="Хадгалаад шинэ" />
                    </div>
                    <div style={{ marginLeft: 16 }}>
                        <ButtonDefault text="Хадгалах" onClick={() => { onSave(true) }} />
                    </div>
                </div>
            }
        >
            <div style={{ marginTop: 29 }}>
                <FieldText autoComplete='username' required onChanged={fieldOnChanged} disable={props.userid ? true : false} title="Нэвтрэх нэр" keyfield='userid' defaultValue={data.userid} checkreq={checkRule} />
            </div>
            <FieldEmployee title="Ажилтан сонгох" onChanged={fieldOnChanged} keyfield="empid" defaultValue={data.empid} defaultText={data.fullname} />
            <div style={{ marginTop: 13 }}>
                <FieldText required onChanged={fieldOnChanged} title="И-мэйл" keyfield='email' defaultValue={data.email} checkreq={checkRule} />
            </div>
            <div style={{ marginTop: 13 }}>
                <FieldDropdown required onChanged={fieldOnChanged} title="Үүрэг" loading={isLoad} data={roleData} onRenderList={onRenderList} keyfield='roleid' defaultValue={data.roleid} />
            </div>
            <div style={{ marginTop: 13 }}>
                <FieldDropdownMulti onChanged={fieldOnChanged} title="Мэдээлэл" loading={isLoad} data={depData} keyfield='depids' defaultValue={data.depids} />
            </div>
            {userid ? (
                <div style={{ marginTop: 13 }}>
                    <FieldDropdown onChanged={fieldOnChanged} title="Төлөв" data={dType} loading={isLoad} keyfield='status' defaultValue={data.status} />
                </div>) : null}
            <div style={{ marginTop: 13 }}>
                <FieldText required type="password" onChanged={fieldOnChanged} title="Нууц үг" keyfield='password' defaultValue={data.password} checkreq={checkRule} />
            </div>
        </PanelBase>
    );
}

export default UserNew;